import { Button } from '@/components/shadcn/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/popover'
import { IconV2FilterOutline } from '@icons/IconV2FilterOutline'

export function TileFilterPopover({
  children,
  open,
  onOpenChange,
  icon,
  portal = true,
}: {
  children: React.ReactNode
  open: boolean
  onOpenChange: (open: boolean) => void
  icon?: React.ReactNode
  /** When false, keeps the popover in the DOM tree (e.g. inside a portalled sheet) so overflow scrolling works. */
  portal?: boolean
}) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="p-0">
          {icon ?? <IconV2FilterOutline size={20} />}
          <span className="sr-only">Open filters</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        portal={portal}
        collisionPadding={16}
        className="max-h-[min(80vh,var(--radix-popover-content-available-height))] w-80 overflow-y-auto rounded-xl bg-offwhite"
      >
        {children}
      </PopoverContent>
    </Popover>
  )
}
